import { Component, Inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { TranslationInitService } from './services/translation-init.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { DOCUMENT } from '@angular/common';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  showSearchModal = false;

  showImageModal = false;
  modalImageUrl = '';
  modalImageAlt = '';

  availableLanguages = [
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' }
  ];
  
  constructor(
    private translateService: TranslateService,
    private translationInitService: TranslationInitService,
    private router: Router,
    private googleAnalytics: GoogleAnalyticsService,
    @Inject(DOCUMENT) private document: Document
  )
  {
    translateService.addLangs(['en', 'fr']);

    const hostname = this.document.location.hostname;

    if (environment.frHostname && hostname === environment.frHostname) {
      translateService.setDefaultLang('fr');
      translateService.use('fr');
    } else {
      translateService.setDefaultLang('en');
      translateService.use('en');
    }

    this.googleAnalytics.initialize();
  }

  ngOnInit() {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(event => {
      this.showSearchModal = false;
      this.googleAnalytics.trackPageView(event.urlAfterRedirects);
    });
  }

  openImageModal(imageUrl: string, altText: string = ''): void {
    this.modalImageUrl = imageUrl;
    this.modalImageAlt = altText;
    this.showImageModal = true;
    // Prevent body scrolling when modal is open
    document.body.classList.add('modal-open');
  }
  
  closeImageModal(): void {
    this.showImageModal = false;
    // Re-enable body scrolling
    document.body.classList.remove('modal-open');
  }

  toggleSearchModal() {
    this.showSearchModal = !this.showSearchModal;
  }

  switchLanguage(lang: string) {
    this.translateService.use(lang);

    this.translationInitService.initTranslations().then(() => {
      const currentUrl = this.router.url;

      if (environment.production && currentUrl === '/introduction' && lang === 'fr' && environment.frUrl) {
        location.href = environment.frUrl;
        return;
      }

      if (environment.production && currentUrl === '/introduction' && lang === 'en' && environment.frHostname) {
        const hostname = this.document.location.hostname;
        if (hostname === environment.frHostname) {
          location.href = `${environment.enUrl}/introduction`;
          return;
        }
      }

      if(environment.production) {
        console.log(`Switched language to ${lang}, reloading current route: ${currentUrl}`);
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });
      }
      
    });
  }
}